import axios from 'axios';
import {
  POST, GET, API_REQUEST, apiError, apiSuccess
} from '../../../actions/api';

export const apiMiddleware = ({ dispatch }) => (next) => (action) => {
  if (!action) return;
  next(action);
  if (action && action.type.includes(API_REQUEST)) {
    const { headers, url, method, feature } = action.meta;
    const params = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };
    if (headers && headers.length > 0) {
      headers.forEach((item) => {
        params[Object.keys(item)[0]] = Object.values(item)[0];
      });
    }

    if (method === POST) {
      axios.post(url, action.payload, { headers: params })
        .then((response) => (dispatch(apiSuccess({ data: response.data, feature }))))
        .catch((error) => dispatch(apiError({ error, feature })));
    }

    if (method === GET) {
      axios.get(url, { headers: params })
        .then((response) => (dispatch(apiSuccess({ data: response.data, feature }))))
        .catch((error) => dispatch(apiError({ error, feature })));
    }
  }
};